var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { Button, Text } from '@ui';
import { translate } from '@utils/i18n';
import apiClient from '@utils/api-client';
import { canRevoke, canSendTest } from '../types';
import './PushDeviceActionsStyles.scss';
const NAMESPACE = 'features.settings.technicians.push_device_status_panel';
/**
 * Refresh, history, send-test and revoke.
 *
 * The two mutating actions were rails-ujs links before this panel was React.
 * They keep their confirm prompts — revoking cuts a real technician off from
 * notifications, and the test button sends a real push to a real device, so
 * neither should fire on a stray click.
 */
export function PushDeviceActions({ status, onRefresh }) {
    const [busy, setBusy] = useState(null);
    const [result, setResult] = useState(null);
    const runAction = (key, url, confirmKey) => __awaiter(this, void 0, void 0, function* () {
        // eslint-disable-next-line no-alert
        if (!window.confirm(translate(confirmKey, { namespace: NAMESPACE })))
            return;
        setBusy(key);
        setResult(null);
        try {
            const response = yield apiClient.post(url);
            setResult(response.data);
            // The platform's view of this recipient may have just changed, so the
            // panel is re-read rather than patched from what we hoped happened.
            yield onRefresh();
        }
        catch (err) {
            setResult({ ok: false, message: translate('action_failed', { namespace: NAMESPACE }) });
        }
        finally {
            setBusy(null);
        }
    });
    return (React.createElement("div", { className: "push-device-actions" },
        React.createElement("div", { className: "push-device-actions__buttons" },
            React.createElement(Button, { variant: "secondary", disabled: busy !== null, onClick: () => {
                    void onRefresh();
                } },
                React.createElement("i", { className: "fa-light fa-arrows-rotate", "aria-hidden": "true" }),
                "\u00A0",
                translate('refresh', { namespace: NAMESPACE })),
            React.createElement("a", { className: "qmb-control", href: status.urls.history }, translate('view_history', { namespace: NAMESPACE })),
            canSendTest(status) && (React.createElement(Button, { variant: "secondary", disabled: busy !== null, onClick: () => {
                    void runAction('test', status.urls.sendTest, 'send_test_confirm');
                } }, busy === 'test'
                ? translate('sending', { namespace: NAMESPACE })
                : translate('send_test', { namespace: NAMESPACE }))),
            canRevoke(status) && (React.createElement(Button, { variant: "danger", disabled: busy !== null, onClick: () => {
                    void runAction('revoke', status.urls.revoke, 'revoke_confirm');
                } }, busy === 'revoke'
                ? translate('revoking', { namespace: NAMESPACE })
                : translate('revoke', { namespace: NAMESPACE })))),
        result && (React.createElement(Text, { variant: "x-small", className: `push-device-actions__result push-device-actions__result--${result.ok ? 'ok' : 'error'}`, role: "alert" }, result.message))));
}
